/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for notification groups.
 * @export
 * @interface NotificationGroupCreate
 */
export interface NotificationGroupCreate {
    /**
     * 
     * @type {number}
     * @memberof NotificationGroupCreate
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationGroupCreate
     */
    owner?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationGroupCreate
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationGroupCreate
     */
    channels?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationGroupCreate
     */
    people?: Array<number>;
}

/**
 * Check if a given object implements the NotificationGroupCreate interface.
 */
export function instanceOfNotificationGroupCreate(value: object): value is NotificationGroupCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NotificationGroupCreateFromJSON(json: any): NotificationGroupCreate {
    return NotificationGroupCreateFromJSONTyped(json, false);
}

export function NotificationGroupCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationGroupCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'name': json['name'],
        'channels': json['channels'] == null ? undefined : json['channels'],
        'people': json['people'] == null ? undefined : json['people'],
    };
}

export function NotificationGroupCreateToJSON(json: any): NotificationGroupCreate {
    return NotificationGroupCreateToJSONTyped(json, false);
}

export function NotificationGroupCreateToJSONTyped(value?: Omit<NotificationGroupCreate, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'name': value['name'],
        'channels': value['channels'],
        'people': value['people'],
    };
}

